import React, { useMemo } from 'react'
import PropTypes from 'prop-types'
import isUndefined from 'lodash/isUndefined'
import { GENDERS } from 'helpers/constants'

const formatValue = value => (isUndefined(value) ? '-' : value)

const PADDING_CLASS = 'px-2'

const Th = ({ children }) => <th className={PADDING_CLASS}>{children}</th>
const Td = ({ children }) => <td className={PADDING_CLASS}>{children}</td>

const TEXT_MAP = {
  [GENDERS.MALE]: 'Male',
  [GENDERS.FEMALE]: 'Female',
  everyone: 'Everyone',
  OTHERS: 'Others',
}

const TicketBreakdown = ({ tickets }) => {
  const formattedSales = useMemo(
    () =>
      tickets.map(({ sold, available, gender, genderPreference }) => ({
        gender: TEXT_MAP[gender],
        genderPreference: TEXT_MAP[genderPreference],
        sold: formatValue(sold),
        available: formatValue(available),
      })),
    [tickets]
  )

  return (
    <div className="px-2 py-2">
      <table className="table-auto">
        <thead>
          <tr>
            <Th>Tickets</Th>
            <Th>Sold</Th>
            <Th>Available</Th>
          </tr>
        </thead>
        <tbody>
          {formattedSales.map((sale, index) => (
            <tr key={index}>
              <Td>
                {sale.gender} > {sale.genderPreference}
              </Td>
              <Td>{sale.sold}</Td>
              <Td>{sale.available}</Td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  )
}

TicketBreakdown.propTypes = {
  tickets: PropTypes.arrayOf(
    PropTypes.shape({
      gender: PropTypes.string,
      genderPreference: PropTypes.string,
      sold: PropTypes.number,
      available: PropTypes.number,
    })
  ),
}

export default TicketBreakdown
